import {IntegrationCard, SalesforceIcon} from "@tinct/web-components";
import {useGetCurrentWorkspaceId} from "@tinct/core-workspace";
import {useDeleteCrmIntegration, useGetOrganizationById} from "@tinct/core-api";
import {useMemo} from "react";
import {useOAuthPopup} from "../pages/edit-integrations-page/hooks/use-oauth-popup";

export const SalesforceIntegration = () => {
  const workspaceId = useGetCurrentWorkspaceId();

  const { mutate: deleteCrmIntegration } = useDeleteCrmIntegration();
  const { openOAuthPopup } = useOAuthPopup({
    organizationId: workspaceId,
    provider: 'salesforce',
  });

  const { data: organization } = useGetOrganizationById({
    id: workspaceId,
    fields: {
      crmIntegrations: {
        fields: {
          id: null,
          providerType: null,
          status: null,
          errorDetails: null,
        }
      }
    }
  }, {
    enabled: !!workspaceId,
  });

  const salesforceIntegration = useMemo(() => {
    return organization?.crmIntegrations?.find(integration => integration.providerType === 'salesforce');
  }, [organization]);

  const connected = !!salesforceIntegration;

  const handleDisconnectSalesforce = () => {
    if (!workspaceId || !salesforceIntegration?.id) return;
    deleteCrmIntegration({
      integrationId: salesforceIntegration.id,
      organizationId: workspaceId,
    })
  }

  return <IntegrationCard
    title="Salesforce"
    description="Enrich companies and sync visitor engagement to your CRM"
    status={connected ? "connected" : "not-connected"}
    icon={<SalesforceIcon width={40} height={40}/>}
    active={true}
    enabled={connected}
    onEnabledChange={(enabled) => {
      if (enabled) {
        openOAuthPopup();
      } else {
        handleDisconnectSalesforce();
      }
    }}
  />
}
